import {
  CREATE_APPSFLYER_INTEGRATION,
  UPDATE_APPSFLYER_INTEGRATION,
  APPSFLYER_INTEGRATION_FETCHED_SUCCESS,
  APPSFLYER_INTEGRATION_FETCHED_FAILED,
  RESET_APPSFLYER_INTEGRATION,
  UNLOAD_APPSFLYER_INTEGRATION,
} from '../constants/actionTypes';

const initialState = {
  appsflyerIntegration: [],
  message: '',
  errors: null,
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default function appsflyerIntegrationReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case CREATE_APPSFLYER_INTEGRATION:
    case UPDATE_APPSFLYER_INTEGRATION:
      return {
        ...state,
        errors: action.payload?.errors || null,
        message: action.payload?.msg || '',
      };

    case APPSFLYER_INTEGRATION_FETCHED_SUCCESS:
      return {
        ...state,
        appsflyerIntegration: action.payload?.appsflyerIntegration || [],
        pager: action.payload?.pager || initialState.pager,
        errors: null,
      };

    case APPSFLYER_INTEGRATION_FETCHED_FAILED:
      return {
        ...state,
        appsflyerIntegration: [],
        errors: 'Failed to load AppsFlyer integrations',
      };

    case RESET_APPSFLYER_INTEGRATION:
    case UNLOAD_APPSFLYER_INTEGRATION:
      return initialState;

    default:
      return state;
  }
}
